<template>
  <BasicTabs v-if="isDataReady" networkName="linkedin" :tabActive="tabActive" @tab-change="$emit('update:tabActive', $event)">
    <template v-slot:overview>
      <div class="block-cards-wrapper" v-loading="!isDataReady && getLoadingLinkedin" :element-loading-text="$t('portals.list.chargementDonnees')">
        <div class="box-card-linkedin">
          <h2>{{ $t('statisticsLinkedin.titleLinkedin') }}</h2>
          <h3>{{ $t('statisticsLinkedin.discover')}}</h3>
          <StatisticItem
              :attribute="$t('statisticsLinkedin.followersNumber')"
              filename="follower.png"
              :label="$t('statisticsLinkedin.followersNumber')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.followersCount : 0"
          />
          <StatisticItem
              :attribute="$t('statisticsLinkedin.numberImpressionTotal')"
              filename="nbPublication.png"
              :label="$t('statisticsLinkedin.numberImpressionTotal')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.uniqueImpressionsCount : 0"
          />
          <StatisticItem
              :attribute="$t('statisticsMeta.likes')"
              filename="like.png"
              :label="$t('statisticsMeta.likes')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.likeCount : 0"
          />
          <StatisticItem
              :attribute="$t('statisticsMeta.comments')"
              filename="comment.png"
              :label="$t('statisticsMeta.comments')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.commentMentionsCount : 0"
          />
          <StatisticItem
              :attribute="$t('statisticsMeta.shares')"
              filename="share.png"
              :label="$t('statisticsMeta.shares')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.shareCount : 0"
          />
          <StatisticItem
              :attribute="$t('statisticsLinkedin.numberCliksOntheLink')"
              filename="click.png"
              :label="$t('statisticsLinkedin.numberCliksOntheLink')"
              :value="('uniqueImpressionsCount' in getStatisticsLinkedin) ? getStatisticsLinkedin.clickCount : 0"
          />
        </div>
        <div class="box-card-linkedin">
          <h2>{{ $t('statisticsLinkedin.growingYourLinkedinCommunity') }}</h2>
          <!--                Stats graphique-->
          <LineChart :chartData="getLineChartDataLinkedin" :chartOptions="getLineChartOptions"></LineChart>
        </div>
      </div>
    </template>
    <template v-slot:publicationReport>
      <h3>{{ $t('statisticsLinkedin.postsLinkedin') }}</h3>
      <PublicationCardLinkedin />
    </template>
  </BasicTabs>
  <div v-else>
    <BoxInfos @closeBoxInfos="closeBoxInfos" :has-icon-info="true" :has-icon-close="false">
      <p style="font-size: 18px;"><strong>{{$t('autoOpenDialogLinkedin.title')}}</strong></p>
      <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialogLinkedin.content')}}</p>
      <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialogLinkedin.content1')}}</p>
      <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialogLinkedin.content2')}}</p>
      <el-button type="primary" class="mb-3" @click="$router.push('/socialNetworks')">{{$t('autoOpenDialogLinkedin.titleConfirmButton')}}</el-button>
    </BoxInfos>
  </div>
</template>
<script>
import StatisticItem from '@/pages/statistics/statisticsMeta/components/StatisticItem.vue'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import BasicTabs from '@/pages/statistics/statisticsMeta/components/BasicTabs.vue'
import moment from 'moment/moment'
import LineChart from '@/chart/LineChart.vue'
import { $t } from '@/i18n'
import PublicationCardLinkedin from '@/pages/statistics/statisticsLinkedin/components/PublicationCardLinkedin.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StatisticsLinkedin',
  props: ['tabActive'],
  components: {
    PublicationCardLinkedin,
    LineChart,
    StatisticItem,
    BoxInfos,
    BasicTabs
  },
  data () {
    return {
      showBoxInfos: true
    }
  },
  computed: {
    ...mapGetters('statisticsLinkedin', ['getStatisticsLinkedin', 'getLoadingLinkedin', 'getGraphStatsLinkedin', 'getPostsLinkedin']),
    moment () {
      return moment
    },
    isDataReady () {
      return !(this.getPostsLinkedin.error && this.getStatisticsLinkedin.error && this.getGraphStatsLinkedin.error)
    },
    getLineChartOptions () {
      return {
        responsive: true,
        lineTension: 1,
        scales: {
          y: {
            beginAtZero: true,
            padding: 25
          }
        }
      }
    },
    getLineChartDataLinkedin () {
      if (this.getGraphStatsLinkedin && this.getGraphStatsLinkedin.followers && this.getGraphStatsLinkedin.followers.length > 0 && this.getGraphStatsLinkedin.dates.length > 0) {
        const dates = this.getGraphStatsLinkedin.dates
        const allDates = dates.map((item) => moment(item).format('DD/MM/YYYY'))
        const valuesStats = this.getGraphStatsLinkedin.followers.map((stat) => stat)
        return {
          labels: allDates,
          datasets: [
            {
              label: $t('statisticsLinkedin.followersNumberByMonth'),
              data: valuesStats,
              borderColor: '#00a4bd',
              borderWidth: 1
            }
          ]
        }
      } else {
        return {
          labels: [],
          datasets: []
        }
      }
    }
  },
  methods: {
    closeBoxInfos (args) {
      if (args === 'close') {
        this.showBoxInfos = false
      }
    }
  },
  mounted () {
    this.$store.dispatch('statisticsLinkedin/loadStatisticsLinkedin')
    this.$store.commit('statisticsLinkedin/setFilters', { key: 'count', value: 10 })
    this.$store.commit('statisticsLinkedin/setFilters', { key: 'start', value: 1 })
  }
}
</script>
<style scoped>
h3 {
  color: #00a4bd;
  font-weight: 600;
  text-transform: Capitalize;
  font-size: 20px;
  margin-top: 20px;
}

.box-card-linkedin {
  margin: 5px;
  width: 45%;
  min-width: 430px;
  min-height: 500px;
  padding: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.el-icon-question{
  font-size: 15px;
}
.block-cards-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

</style>
